import React from 'react'

export default function footer() {
    return (
        <footer>
            <div> Expense tracking Platform</div>
            <div>Accenture Technologies Pvt. Ltd.</div>
            <div>Nitin Gupta || 2021</div>
        </footer>
    )
}
